import { MatDialog } from '@angular/material';
import { VideoComponent } from '../video/video.component';

export class OpenVideo {
    constructor(public dialog: MatDialog) {
    }

    openVideoDialog(_e: Object, PromotionBackgroundVideoUrl: String, PromotionalVideoTitle: String): void {
        this.dialog.open(VideoComponent, {
            panelClass: 'video-panel',
            backdropClass: 'white-opaque-backdrop',
            data: {
                PromotionBackgroundVideoUrl: PromotionBackgroundVideoUrl,
                PromotionBackgroundVideoTitle: PromotionalVideoTitle ? PromotionalVideoTitle : 'Embedded Video'
            }
        });

    }
}
